<template>
  <div>
    <template v-for="(datarow, index) in currentRows">
      <!-- проходим по всем строкам источника и передаем в компонент только текущую строку -->
      <component
        v-for="widget in model.Widgets"
        :key="widget.$ID + index"
        :is="widget.$Type"
        :model="widget"
        @callDataSourceAction="onCallDataSourceAction($event, datarow)"
        :dataSource="{ data:datarow,parentDataSource:dataSource }"
      />
    </template>
    <div v-if="needPagination" class="d-flex justify-end align-center test" >
      <div class=" d-flex justify-center align-baseline dr-widget-list-pagination-container">
        <div>{{ $t('drWidgetList.itemsPerPage') }}:</div>
        <div class="ml-6 mr-6 d-flex dr-widget-list-pagination-select-container">
          <v-select
            class="dr-widget-list-select"
            height="20px"
            v-model="currentItemsPerPage"
            :items="getAmountElementsPerPage()"
            color="black"
            @input="changeAmountLines"
          >
          </v-select>
        </div>
        {{ rangeLinesLabel }} {{ $t('drWidgetList.of') }} {{ elementsLength }}
        <div class="ml-6">
          <v-btn small icon :disabled="disableLeft" @click="prevPage"><v-icon>mdi-menu-left</v-icon></v-btn>
          <v-btn small icon :disabled="disableRight" @click="nextPage"><v-icon>mdi-menu-right</v-icon></v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import uk from '../../langs/widgetList/uk.json'
import ru from '../../langs/widgetList/ru.json'
import en from '../../langs/widgetList/en.json'
import mixin from '../../mixins/base-mixin'
import inputMixin from '../../mixins/input-mixin'
import microflowMixin from '../../mixins/microflow-mixin'
import actionMixin from '../../mixins/actions-mixin'

export default {
  name: 'dr-widget-list-component',
  mixins: [mixin, inputMixin, microflowMixin, actionMixin],
  data: () => ({
    page: 1, // Страница
    currentItemsPerPage: 1, // Отображаемое кол-во элементов
    initialItemsPerPage: 0 // Копия отображения кол-ва страниц, используется для вычисления возможного выбора кол-ва страниц
  }),
  mounted() {
    const linesPerPage = this.model.Pagination?.LinesPerPage || this.model.LinesPerPage
    this.currentItemsPerPage = parseInt(linesPerPage) || 1
    this.initialItemsPerPage = this.currentItemsPerPage
  },
  computed: {
    // Текущие элементы для отображения
    currentRows () {
      let filteredRows = this.filteredRows
      
      if (!this.needPagination) {
        return filteredRows
      }

      // при асинхронном режиме, у нас уже есть пагинированые элементы
      if (this.currentItemsPerPage === this.strAll || (this.page > 1 && this.model.Pagination?.AsyncMode)) {
        return filteredRows
      }

      return filteredRows.slice(this.start, this.end)
    },
    // Отфильтрованные элементы для отображения
    filteredRows() {
      const rows = this.getExternalSourceField(this.model.Value)
      if (!rows) {
        return []
      }

      if (this.filterValue.length === 0) {
        return rows
      }
      return rows.filter(x => this.includesRecursive(x, this.filterValue))
    },
    strAll() {
      return this.$t('drWidgetList.all')
    },
    // Начальная часть элементов
    start() {
      return (this.page - 1) * parseInt(this.currentItemsPerPage)
    },
    // Конечная часть элементов
    end() {
      return this.page * parseInt(this.currentItemsPerPage)
    },
    // Установка ренджи элементов  на странице 1-5 
    rangeLinesLabel() {
      let before = this.page === 1 ? 1 : ((this.page - 1) * this.currentItemsPerPage ) + 1
      let after = this.page === this.paginationLength ? this.elementsLength : this.page * this.currentItemsPerPage
      return `${before} - ${after}`
    },
    // Состояние активности кнопки предыдущая страница
    disableLeft() {
      return this.page == 1
    },
    // Состояние активности кнопки следующая страница
    disableRight() {
      return this.page == this.paginationLength
    },
    // Кол-во элементов
    elementsLength () {
      if (!this.needPagination) {
        return this.filteredRows.length
      }

      return this.model.Pagination?.AsyncMode ? this.getExternalSourceField(this.model.Pagination.ItemsCount) : this.filteredRows.length 
    },
    // Кол-во страниц
    paginationLength() {
      let items = this.currentItemsPerPage
      if (this.currentItemsPerPage === this.strAll) {
        items = this.elementsLength
      }
      return Math.ceil(this.elementsLength / parseInt(items)) 
    },
    // Значение поля для поиска
    filterValue() {
      return this.$store.state.general.globalSearch || ''
    },
    needPagination() {
      return this.model.Pagination ? this.model.Pagination.NeedPagination : this.model.NeedPagination
    }
  },
  methods: {
    // Получить заполненный массив для выбора отображения кол-ва элементов на странице
    getAmountElementsPerPage() {
      return [this.initialItemsPerPage, this.initialItemsPerPage * 2, this.initialItemsPerPage * 4, this.strAll]
    },
    // Изменить кол-во элементов на странице
    changeAmountLines(value) {
      this.currentItemsPerPage = value
      this.page = 1

      this.emitChangePagination()
    },
    // Следующая страница
    prevPage() {
      this.page--
      this.emitChangePagination()
    },
    // Предыдущая страница
    nextPage() {
      this.page++
      this.emitChangePagination()
    },
    onCallDataSourceAction(args, datarow) {
      this.$emit('callDataSourceAction', {...args, params: {...args.params, widgetListData: args.params.widgetListData ? args.params.widgetListData : datarow }} )
    },
    onModelChanged() {
      this.$emit('modelChanged', this.model)
    },

    onDeleteWidget(val) {
      this.model.Widgets = this.model.Widgets.filter(comp => comp != val)
      this.$emit('modelChanged', this.model)
      this.widgetsHelper.setSelectedWidget(undefined)
    },
    // Макет как выделеный виджет
    setSelectedWidget() {
      if (this.isInEditorMode) {
        this.widgetsHelper.setSelectedWidget(this.model)
      }
    },
    // Рекурсивная функция поиска совпадений по свойствам обьекта
    includesRecursive(object, value) {
      for (const prop in object) {
        // eslint-disable-next-line no-prototype-builtins
        if (!object.hasOwnProperty(prop)) {
          continue
        }

        if (typeof object[prop] == 'object' && object[prop] != null) {
          return this.includesRecursive(object[prop], value)
        }
        
        if (`${object[prop]}`.includes(value)) {
          return true
        }
      }
      return false
    },
    emitChangePagination() {
      const payload = {
        action: 'widget-list-pagination-change',
        params: {
          currentDataPage: this.page,
          itemsPerPage: this.currentItemsPerPage === this.strAll ? this.elementsLength : this.currentItemsPerPage
        }
      }
      this.$emit('callDataSourceAction', payload)
    }
  },
  i18n: {
    messages: {
      uk,
      en,
      ru
    }
  }
}
</script>

<style>

.dr-widget-list-pagination-container {
  font-size: 12px;
}
.dr-widget-list-pagination-select-container {
  width: 30px;
  min-width: 30px;
}

.dr-widget-list-editor-mode{
border: 1px solid rgb(0, 60, 255);
  min-height: 50px;
  padding: 10px;
  margin-top: 10px;
  margin-bottom: 10px;
}
.dr-widget-list-selected{
  outline: 2px solid #ffa500;
  outline-offset: -2px;
}

.dr-widget-list-select .v-input__slot .v-select__slot .v-input__append-inner {
  align-self: auto !important;
  display: flex !important;
  margin: 0;
}

.dr-widget-list-select .v-input__slot .v-select__slot .v-input__append-inner .v-input__icon{
  max-width: 10px !important;
  height: 10px !important;
  min-width: 10px !important;
}
.dr-widget-list-select .v-input__slot .v-select__slot .v-select__selections .v-select__selection--comma {
  font-size: 12px;
  margin: 0px;
}
.dr-widget-list-select .v-input__slot .v-select__slot .v-input__append-inner .v-input__icon .v-icon{
  font-size: 18px;
  
}
.dr-widget-list-select .v-input__slot {
  margin-bottom: 0px;
}
</style>
